<template>
    <card plain title="">
        <div>
            <b-table show-empty :fields="fields" :items="claims">
                <template #cell(info)="data">
                    <b-icon-exclamation-circle v-b-modal.billing-details-modal @click="$emit('detailsClaim', data.item)"
                        variant="info"></b-icon-exclamation-circle>
                </template>
                <template #cell(usualAndCustomary)="data">{{ data.value || 0 | currency }}</template>
                <template #cell(adjudicated)="data">{{ data.value || 0 | currency }}</template>
                <template #cell(planPaid)="data">{{ data.value || 0 | currency }}</template>
                <template #cell(voucherPaid)="data">{{ data.value || 0 | currency }}</template>
                <template #cell(patientPay)="data"><b>{{ data.value || 0 | currency }}</b></template>
                <template #cell(transactionStatus)="data">
                    <b v-if="data.value === 'Rejected'" style="color: red">
                        {{ data.value }}
                    </b>
                    <b v-else-if="data.value === 'Approved'" style="color:green">
                        {{ data.value }}
                    </b>
                    <b v-else>
                        {{ data.value }}
                    </b>
                </template>
                <template #cell(updatedBy)="data">
                    <div class="text-truncate">
                        {{ data.value }}
                    </div>
                </template>
            </b-table>
        </div>
    </card>
</template>

<script lang="ts">

import { Component, Vue, VModel, Watch } from "vue-property-decorator";
import { Prescription } from "@/models/Prescription";
import { Claim } from "@/models/Claim";
import axios, { AxiosRequestConfig } from "axios";
import { BvTableFieldArray } from "bootstrap-vue";
import moment from "moment";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({
    name: "ClaimComponent"
})
export default class ClaimComponent extends Vue {
    @VModel() private prescription!: Prescription;
    protected claims: Claim[] = [];

    protected get fields(): BvTableFieldArray {
        const allFields = [
            { key: "info", label: "" },
            { key: "planName", label: "Plan", },
            { key: "transactionStatus", label: "Status", },
            { key: "usualAndCustomary", label: "Submitted", },
            { key: "adjudicated", label: "Adjudicated", },
            { key: "planPaid", label: "Plan Paid" },
            { key: "voucherPaid", label: "Voucher Paid", },
            { key: "patientPay", label: "Copay", },
            { key: "created", formatter: (d: string) => d ? moment(d).format("L") : "" },
            { key: "reversed", formatter: (d: string) => d ? moment(d).format("L") : "" },
            {
                key: "isForceReversed",
                label: "Force Reversed",
                formatter: (value: boolean) => value ? "Yes" : "",
                tdClass: (value: boolean) => value ? 'text-danger font-weight-bold' : '',
                hidden: !this.claims.some(c => c.isForceReversed)
            },
            { key: "updatedBy", label: "Updated By", thStyle: { maxWidth: "150px", width: "150px" }, class: "updated" },
        ];

        return allFields.filter(f => !f.hidden);
    }

    @Watch("value")
    prescriptionUpdated(_rx: Prescription, _oldRx: Prescription) {
        this.fetchClaims();
    }

    mounted() {
        this.fetchClaims();
    }

    fetchClaims() {
        const rx = this.prescription;
        const config: AxiosRequestConfig = {
            params: {
                getReversed: true
            }
        };
        axios.get(`Insurance/GetClaims/${rx.storeID}/${rx.rxNumber}/${rx.rfNumber}`, config)
            .then(resp => {
                console.log("resp.data", resp.data);
                this.claims = resp.data;
            })
            .catch(err => {
                console.warn("get claims err: ", err);
                this.$notification(NotificationOptions.error(err));
            });
    }
}
</script>

<style scoped>
::v-deep(.text-truncate) {
    white-space: wrap;
    width: 220px;
}
</style>
